import EmptyState from './EmptyState';

type Props = {
    titleId?: string;
};

/**
 * Thin wrapper over the `inline` tier of {@link EmptyState}, kept so existing call sites keep their
 * one-prop signature and pick up the design unchanged. New surfaces should use `EmptyState`
 * directly and pick the tier that fits the space.
 */
const NoData = ({ titleId = 'no-data' }: Props): JSX.Element => {
    return <EmptyState size="inline" titleId={titleId} />;
};

export default NoData;
